import apiConfig from "@apiConfig";
import http from "@core/fetch";
import { useData } from "@hooks/useData";
import { ICategoryProfile } from "@apiHooks/useCategoryProfile";

const REQUEST_TYPE: keyof typeof apiConfig = 'get category profiles';

// Stable references: useData's useCallback depends on both, so inline values would refetch in a loop.
const DEFAULT_PROFILES: ICategoryProfile[] = [];

// No try/catch on purpose: a rejection lets useData flag isSuccess = false.
// http.get is untyped (fetch.js), so the cast narrows to the known response shape.
async function getCategoryProfiles(): Promise<ICategoryProfile[]> {
    return await http.get(REQUEST_TYPE) as ICategoryProfile[];
}

export default function useCategoryProfiles() {
    const { data: profiles, isLoading, isSuccess, reFetch } = useData<ICategoryProfile[]>(
        DEFAULT_PROFILES,
        getCategoryProfiles,
    );

    return {
        profiles,
        isLoading,
        isError: isSuccess === false,
        reFetch,
    };
}
